import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { select, Store } from '@ngrx/store';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
	constructor(private authStore: Store<{ auth: { token: string } }>) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const upn = localStorage.getItem('upn');
		let customHeaders;
		const validPaths = ['authorization', 'drilling/well-operations/subsurface-progress-ingestion'];
		let token;

		this.authStore.pipe(select('auth')).subscribe((d) => {
			token = d.token;
		});

		if (validPaths.filter((d) => request.url.includes(d)).length > 0 && token) {
			customHeaders = {
				'X-User-Id': upn,
				'X-Client-Id': 'NextWave',
				'X-Trace-Id': uuidv4(),
				Authorization: `Bearer ${token}`,
			};
		}
		const modifiedRequest = request.clone({
			setHeaders: customHeaders,
		});
		return next.handle(modifiedRequest);
	}
}
